import { Form, Offcanvas } from "react-bootstrap";
import { useForm } from "react-hook-form";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";

interface EventFormData {
  show: boolean;
  handleClose: () => void;
  data?: any;
}

type FormData = {
  name: string;
  type: string;
};

const AddCategory = ({ show, handleClose, data }: EventFormData) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormData>();
  const [isLoading, setLoading] = useState(false);

  // ✅ Dropdown options with different id and label
  const categoryTypes = [
    // { id: "EVENT", label: "Event" },
    // { id: "MEMBER", label: "Member" },
    { id: "ORGANIZATION", label: "Organization" },
    { id: "GET_TOUCH", label: "Get in Touch" },
    { id: "GALLERY", label: "Gallery" },
    { id: "INDUSTRY_REPORT", label: "Industry Report" },
    { id: "TENDERS", label: "Tenders" },
    { id: "PRESENTATION", label: "Presentation" },
    { id: "KNW_PAPER", label: "Monthly Report" },
    { id: "RESOURCE_INDEX", label: "Index" },
    { id: "WORKING_GROUP", label: "Working Group" },
    { id: "REGULATION", label: "Representations" },
  ];

  useEffect(() => {
    if (data) {
      reset({
        name: data.name,
        type: data.type ? data.type.toUpperCase() : "",
      });
    } else {
     reset({
      name: "",
      type: "",
    });
    }
  }, [data, reset]);

  const onSubmit = (request: FormData) => {
    setLoading(true);
    if (data?._id) {
      WebService.putAPI({
        action: `categories/editCategory/${data._id}`,
        body: request,
      })
        .then((res: any) => {
          toast.success(res.message);
          setLoading(false);
          handleClose();
          reset();
        })
        .catch((error: any) => {
          setLoading(false);
          toast.error(error.response?.data?.message || "An error occurred");
        });
    } else {
      WebService.postAPI({
        action: `categories/addCategory`,
        body: request,
      })
        .then((res: any) => {
          toast.success(res.message);
          setLoading(false);
          handleClose();
          reset();
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response?.data?.message || "An error occurred");
        });
    }
  };

  return (
    <>
      <Offcanvas
        show={show}
        onHide={() => {
          reset();
          handleClose();
        }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {data ? "Edit Category" : "Add Category"}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form>
            <Form.Group className="mb-2" controlId="categoryName">
              <Form.Label className="label">Category Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter category name"
                {...register("name", { required: "Category name is required" })}
              />
              {errors.name && (
                <div className="error-message">{errors.name.message}</div>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="tagType">
              <Form.Label className="label">
                Type <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                {...register("type", { required: "Type is required" })}
              >
                <option value="">Select Type</option>
                {categoryTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.label}
                  </option>
                ))}
              </Form.Select>
              {errors.type && (
                <div className="error-message">{errors.type.message}</div>
              )}
            </Form.Group>
          </Form>
        </Offcanvas.Body>
        <div className="d-flex justify-content-end p-3">
          <CustomButton
            isLoading={isLoading}
            label="Save"
            className="w-100"
            onClick={handleSubmit(onSubmit)}
          />
        </div>
      </Offcanvas>
    </>
  );
};

export default AddCategory;
